export default "__VITE_ASSET__Dea_DKUd__"